export const AGENT_NAMES = {
  general: 'general',
  postAgent: 'post-agent',
  projectAutofillAgent: 'project-autofill',
  generalAgent: 'general-agent'
} as const

export type AgentName = (typeof AGENT_NAMES)[keyof typeof AGENT_NAMES]

const LEGACY_PROJECT_AUTOFILL_AGENT_ID = 'project-autofill-agent'

export const isProjectAutofillAgentId = (id: string | null | undefined): boolean =>
  id === AGENT_NAMES.projectAutofillAgent || id === LEGACY_PROJECT_AUTOFILL_AGENT_ID

export const ACTION_ID_TO_AGENT: Record<string, string> = {
  'post-agent': AGENT_NAMES.postAgent,
  'project-autofill': AGENT_NAMES.projectAutofillAgent,
  'derivar-especialista-proyecto': AGENT_NAMES.projectAutofillAgent
}

export const SUGGESTED_ACTION_ID_TO_AGENT: Record<string, string> = {
  ...ACTION_ID_TO_AGENT,
  'crear-post': AGENT_NAMES.postAgent,
  'crear-portfolio': AGENT_NAMES.postAgent,
  'volver-general': AGENT_NAMES.general
}

const SUGGESTED_CHIP_NO_ACTIVE_AGENT_OVERRIDE = new Set([
  'project-autofill',
  'derivar-especialista-proyecto',
  'comercializar-documentacion'
])

export const suggestedChipSkipsActiveAgentOverride = (actionId: string): boolean =>
  SUGGESTED_CHIP_NO_ACTIVE_AGENT_OVERRIDE.has(actionId)

export const GUIDE_ACTION_IDS_WITH_SPECIALIST: string[] = [
  'ofrecer-servicios',
  'analizar-docs-obra-cotizaciones',
  'comercializar-documentacion',
  'presupuestos-obra',
  'derivar-especialista-proyecto',
  'project-autofill'
]
